import { AvailableRate } from '../types';

type RatePaymentTerms = AvailableRate['payment_terms'];

const zeroedPaymentTerms = (paymentTerms: RatePaymentTerms): RatePaymentTerms => {
  if (!paymentTerms?.amount_due_now) {
    return paymentTerms;
  }

  return {
    ...paymentTerms,
    amount_due_now: { ...paymentTerms.amount_due_now, amount: 0 },
  };
};

const addAmountDueNow = (
  currentTotal: RatePaymentTerms,
  paymentTerms: RatePaymentTerms,
  count: number
): RatePaymentTerms => {
  if (!currentTotal?.amount_due_now) {
    if (!paymentTerms?.amount_due_now) {
      return currentTotal;
    }

    return {
      ...paymentTerms,
      amount_due_now: {
        ...paymentTerms.amount_due_now,
        amount: paymentTerms.amount_due_now.amount * count,
      },
    };
  }

  return {
    ...currentTotal,
    amount_due_now: {
      ...currentTotal.amount_due_now,
      amount:
        currentTotal.amount_due_now.amount + (paymentTerms?.amount_due_now?.amount || 0) * count,
    },
  };
};

export const getTotalFromPricesForRates = (
  availableRates: (AvailableRate & {
    price_per_night?: { amount: number; currency_code: string };
    count: number;
  })[][]
) => {
  const ratePriceMap = new Map();
  availableRates.flat().forEach((rate) => {
    const currentTotal = ratePriceMap.get(rate.id) || {
      price_per_night: {
        ...rate.price_per_night,
        amount: rate.price_per_night ? 0 : undefined,
      },
      from_price: {
        ...rate.from_price,
        amount: 0,
      },
      payment_terms: zeroedPaymentTerms(rate.payment_terms),
    };
    ratePriceMap.set(rate.id, {
      price_per_night: rate.price_per_night
        ? {
            ...rate.price_per_night,
            amount:
              currentTotal.price_per_night.amount +
              (rate.price_per_night?.amount || 0) * rate.count,
          }
        : undefined,
      from_price: {
        ...rate.from_price,
        amount: currentTotal.from_price.amount + (rate.from_price?.amount || 0) * rate.count,
      },
      payment_terms: addAmountDueNow(currentTotal.payment_terms, rate.payment_terms, rate.count),
    });
  });
  return ratePriceMap;
};
